import {WebFormModel} from "capitalist-shared/src/core/model";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import {httpBackofficeAxiosApi} from "@/shared/axios.backoffice.helper";

export class TronPaymentGuess {
    txid: ''
    canBeMinedLater: false
    checkUrl: ''
}

export class TronPaymentGuessModel extends WebFormModel {

    loadingStatus = new RemoteRequestState()

    getPaymentGuess(id: string | number | null, investDocument = false) {
        this.loadingStatus.loadStart();
        this.errors.clear();
        return httpBackofficeAxiosApi.post('/backofficeapi/crypto/tron', {
            call: 'paymentFuture',
            id: id,
            investDocument: investDocument
        }).then((response) => {
            this.loadingStatus.loadEnd()
            return Object.assign({}, new TronPaymentGuess, response.data);
        }).catch((error) => {
            this.checkAxiosError(error);
            this.loadingStatus.loadError();
            throw error;
        });
    }
}
